import { useState } from 'react';
import { IPackagesList, PackageType } from '../../../../interfaces';

export const usePackageSelection = ({
    packageType,
    packages,
    initialSelectedPackages,
}: {
    packageType: PackageType;
    packages: IPackagesList;
    initialSelectedPackages: number[];
}) => {
    const [selectedPackages, setSelectedPackages] = useState<number[]>(initialSelectedPackages);
    const [isCreateMode, setIsCreateMode] = useState(false);

    const handlePackageToggle = (packageId: number) => {
        if (packageType === 'local') {
            setSelectedPackages([packageId]);
        } else {
            setSelectedPackages((prev) => {
                if (prev.includes(packageId)) {
                    return prev.filter((id) => id !== packageId);
                } else {
                    return [...prev, packageId];
                }
            });
        }
    };

    const handleSelectAll = () => {
        if (packageType === 'roaming') {
            if (selectedPackages.length === packages.length) {
                setSelectedPackages([]);
            } else {
                setSelectedPackages(packages.map((pkg) => +pkg.id));
            }
        }
    };

    const handleCreatePackage = () => {
        setIsCreateMode(true);
    };

    const handleBackToSelect = () => {
        setIsCreateMode(false);
    };

    const isPackageSelected = (packageId: number) => selectedPackages.includes(packageId);

    const canProceed = packageType === 'local' ? selectedPackages.length === 1 : selectedPackages.length > 0;

    return {
        selectedPackages,
        setSelectedPackages,
        isCreateMode,
        setIsCreateMode,
        handlePackageToggle,
        handleSelectAll,
        handleCreatePackage,
        handleBackToSelect,
        isPackageSelected,
        canProceed,
    };
};
